import React from 'react';
import { Search, X } from 'lucide-react';

/**
 * Search box plus filter controls in one bar.
 * filters: [{ component }] — each component is rendered as-is (usually a <select className="pk-select">).
 * Pass `inline` to drop the card frame when the bar sits inside an .adm-panel.
 */
const FilterBar = ({
  searchPlaceholder = 'Search…',
  searchLabel = 'Search',
  searchValue,
  onSearchChange,
  filters = [],
  onClearFilters,
  children,
  end,
  inline = false,
}) => (
  <div className={`adm-toolbar${inline ? '' : ' adm-toolbar--card'}`} role="search">
    {onSearchChange && (
      <div className="pk-input-icon adm-toolbar__search">
        <Search aria-hidden="true" />
        <input
          type="search"
          className="pk-input"
          aria-label={searchLabel}
          placeholder={searchPlaceholder}
          value={searchValue ?? ''}
          onChange={e => onSearchChange(e.target.value)}
        />
      </div>
    )}
    {filters.map((filter, index) => (
      <div className="adm-toolbar__item" key={filter.key ?? index}>
        {filter.component}
      </div>
    ))}
    {children}
    {(onClearFilters || end) && (
      <div className="adm-toolbar__end">
        {end}
        {onClearFilters && (
          <button type="button" className="pk-btn pk-btn--ghost pk-btn--xs" onClick={onClearFilters}>
            <X aria-hidden="true" />
            Clear
          </button>
        )}
      </div>
    )}
  </div>
);

export default FilterBar;
